import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Globals } from 'src/shared/globals';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root' // Makes the service a singleton available throughout the app
})
export class MyProfileService {

  constructor(private httpService: HttpClient, private global: Globals) {
  }

  public getUserProfile(): Observable<any> {
    return this.httpService.get(this.global.apiUrl + 'Account/profile');
  }

  PostService(endPoint: string, body: any): Observable<any> {
    const url = `${this.global.apiUrl}Account/${endPoint}`;
    return this.httpService.post(url, body);
  }

  public SaveProfile(form: FormData): Observable<any> {
    const url = `${this.global.apiUrl}Account/SaveProfile`;
    return this.httpService.post(url, form);
  }
}
